import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "dv-comp",
  "use": "dv-comp-usage",
  "viewBox": "0 0 20 18.57",
  "content": "<symbol viewBox=\"0 0 20 18.57\" id=\"dv-comp\"><title>dv-comp</title><path d=\"M18.41,13.57h1.4a.2.2,0,0,1,.2.2v5.32a.2.2,0,0,1-.2.2H14.48a.2.2,0,0,1-.2-.2V13.77a.2.2,0,0,1,.2-.2h1.4a.2.2,0,0,0,.2-.2V10.91a.2.2,0,0,0-.2-.2H11.27a.2.2,0,0,0-.2.2v2.47a.2.2,0,0,0,.2.2h1.4a.2.2,0,0,1,.2.2v5.32a.2.2,0,0,1-.2.2H7.34a.2.2,0,0,1-.2-.2V13.77a.2.2,0,0,1,.2-.2h1.4a.2.2,0,0,0,.2-.2V10.91a.2.2,0,0,0-.2-.2H4.12a.2.2,0,0,0-.2.2v2.47a.2.2,0,0,0,.2.2h1.4a.2.2,0,0,1,.2.2v5.32a.2.2,0,0,1-.2.2H.2a.2.2,0,0,1-.2-.2V13.77a.2.2,0,0,1,.2-.2h1.4a.2.2,0,0,0,.2-.2V8.77a.2.2,0,0,1,.2-.2H8.73a.2.2,0,0,0,.2-.2V6.62a.2.2,0,0,0-.2-.2H7.34a.2.2,0,0,1-.2-.2V.91a.2.2,0,0,1,.2-.2h5.32a.2.2,0,0,1,.2.2V6.23a.2.2,0,0,1-.2.2h-1.4a.2.2,0,0,0-.2.2V8.38a.2.2,0,0,0,.2.2H18a.2.2,0,0,1,.2.2v4.61A.2.2,0,0,0,18.41,13.57Zm-.2,0\" transform=\"translate(0 -0.71)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/dv-comp.svg
// module id = euQT
// module chunks = 264